module.exports = GLOBAL_CONFIG_FILE;